import React, { useEffect } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { user, loading, isAuthenticated, isAdmin, refreshUser } = useAuth();
  
  // Check if this is an OAuth callback with a token
  const hasOAuthToken = searchParams.get('token') && (searchParams.get('google') || searchParams.get('discord'));
  
  // Handle OAuth token before auth check
  useEffect(() => {
    if (hasOAuthToken) {
      const token = searchParams.get('token');
      if (token) {
        localStorage.setItem('auth_token', token);
        // Trigger auth refresh
        if (refreshUser) {
          refreshUser();
        }
      }
    }
  }, [hasOAuthToken, searchParams, refreshUser]);
  
  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }
  
  // If we have an OAuth token, allow through even if not yet authenticated
  // The Dashboard will handle storing the token and refreshing auth
  if (hasOAuthToken) {
    return children;
  }
  
  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Requires admin but user is not admin
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
